import { IVideoPlayerConfig } from '@gem/ui-kit';

import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function setPlayerConfig(config: Partial<IVideoPlayerConfig>, saveNewValue = true): void {
  const globalVideoPlayer = Entities.GlobalVideoPlayer;
  globalVideoPlayer.setConfig(config);

  if (saveNewValue) {
    storage.videoPlayerConfig.set(JSON.stringify(globalVideoPlayer.config));
  }
}

export function initPlayerConfig(): void {
  const config = storage.videoPlayerConfig.get();

  if (config) {
    try {
      setPlayerConfig(JSON.parse(config), false);
    } catch {
      // nothing have to do
    }
  }
}
